module.exports = __webpack_public_path__ + "static/img/gateway.99e075b7.png";